// removed by extract-text-webpack-plugin
module.exports = {"alignLeft":"_2fiXN","alignRight":"_2KfeU","sizeFullWidth":"_1afAR","sizeContentWidth":"u9NEb","sizeSmallCenter":"_1NIIO","sizeOriginal":"_320qW"};


//////////////////
// WEBPACK FOOTER
// ./app/components/styled-text-editor/media-block-theme.scss
// module id = 821
// module chunks = 3 4 5 6 7